import { Divider, Flex, Row, Skeleton, Col } from "antd";
const ReviewSkeleton = () => {
  return (
    <Flex vertical className="!my-[35px] flex flex-col gap-[15px]">
      <Flex
        justify="space-between"
        align="flex-end"
        className="flex-wrap gap-y-2"
      >
        <Skeleton.Input active size="default" className="w-full sm:w-[48%]" />
        <Skeleton.Input active size="small" className="w-full sm:w-[48%]" />
      </Flex>

      {/* Second row */}
      <Flex
        justify="space-between"
        align="flex-end"
        className="flex-wrap gap-y-2"
      >
        <Skeleton.Input active size="small" className="w-full sm:w-[48%]" />
        <Skeleton.Input active size="small" className="w-full sm:w-[48%]" />
      </Flex>

      {/* Third row */}
      <Flex
        justify="space-between"
        align="flex-end"
        className="flex-wrap gap-y-2"
      >
        <Skeleton.Input active size="small" className="w-full sm:w-[48%]" />
        <Skeleton.Input active size="small" className="w-full sm:w-[48%]" />
      </Flex>

      {/* Full width button */}
      <Skeleton.Button active size="large" className="!w-full mt-[10px]" />

      <Divider />

      {/* Fourth row */}
      <Flex
        justify="space-between"
        align="flex-end"
        className="flex-wrap gap-y-2"
      >
        <Skeleton.Input active size="default" className="w-full sm:w-[48%]" />
        <Skeleton.Input active size="small" className="w-full sm:w-[48%]" />
      </Flex>

      <Divider />

      <Row gutter={[30, 30]}>
        <Col xs={24} sm={16}>
          <Skeleton.Input active size="default" className="!w-full" />
        </Col>
        <Col xs={24} sm={8}>
          <Skeleton.Input active size="default" className="!w-full" />
        </Col>
      </Row>
    </Flex>
  );
};

export default ReviewSkeleton;
